import { render, staticRenderFns } from "./PhasesLiveView.vue?vue&type=template&id=67b4a11c&scoped=true"
import script from "./PhasesLiveView.vue?vue&type=script&lang=ts"
export * from "./PhasesLiveView.vue?vue&type=script&lang=ts"
import style0 from "./PhasesLiveView.vue?vue&type=style&index=0&id=67b4a11c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4a11c",
  null
  
)

export default component.exports